/* eslint-disable import/no-cycle */

import { UserType } from './user';
import { CommonFieldType } from './utils';

export type ProductType = CommonFieldType & {
  name: string;
  description: string;
  imageUrl: string;
  isEnable: boolean;
  sequence: number;
  productPriceLog?: ProductPriceLog[];
  isOrnament?: boolean;
};

export type ProductPriceLog = CommonFieldType & {
  productId: string;
  priceBuyPerUnit: number;
  priceSellPerUnit: number;
  priceBuyPerGram: number;
  priceSellPerGram: number;
  unitName: string;
  currency: string;
  product?: ProductType;
  approvedBy?: string;
  approvedByUser?: UserType;
  approvedByUserId?: string;
};

export enum ProductQuotaType {
  BUY = 'BUY',
  SELL = 'SELL',
}

export type ProductRedeemFeeType = CommonFieldType & {
  productId: string;
  name: string;
  description: string;
  fee: number;
  currency: string;
  weightBaht: number; // น้ำหนักในหน่วยบาท
  weightGram: number; // น้ำหนักในหน่วยกรัม
  unitName?: string; // Optional - สำหรับ backward compatibility
  weight?: number; // Optional - สำหรับ backward compatibility (deprecated)
  createdByUserId: string;
};
